import { getColorAlias } from '../../utils/index.js';
import { Primary, Outlined, Ghost } from './styles.js';

function getIconFill(selected, disabled) {
    if (selected && !disabled) {
        return getColorAlias('contentInteractivePrimary');
    }
    if (disabled)
        return getColorAlias('contentDisabled');
    return getColorAlias('contentInteractiveSecondary');
}
function getHoverCursor(disabled, showClose, selected, isLoading) {
    if (disabled)
        return 'not-allowed';
    if ((selected && showClose) || isLoading)
        return 'default';
    return 'pointer';
}
function getChipVariant(variant) {
    switch (variant) {
        case 'ghost':
            return Ghost;
        case 'outlined':
            return Outlined;
        case 'primary':
        default:
            return Primary;
    }
}

export { getChipVariant, getHoverCursor, getIconFill };
